import { createAction, handleActions } from "redux-actions";

import config from "appConfig";
import {
  api,
  checkEmptyObject
} from "../../services";

import {
  cartInterface,
  rootReducerInterface,
} from "../../typings/interfaces";

import { AdsSortOption, ShoppingCart, ShoppingCartList, ShoppingCartListParsed, ShoppingCartParsed, ShoppingCartResponse } from "../../models";


const parseShoppingCartData = (cart: ShoppingCart[]): ShoppingCartParsed[] => {
  return cart.map((cart) => {
    return {
      id: cart.id,
      createdAt: cart.createdAt,
      name: cart.item.name,
      adTitle: cart.item.adTitle,
      adUrl: cart.item.adUrl,
      invoiceId: cart.invoiceId,
      priceWithoutVat: cart.item.priceWithoutVat,
      vat: cart.item.vat,
      price: cart.item.price,
      status: cart.status,
      paymentMethod: cart.paymentMethod,
      bankTransferInfo: cart.bankTransferInfo,
      type: cart.item.type,
    }
  });
}

const CART_CREATE = "CART_CREATE";
const CART_LIST = "CART_LIST";
const CART_GET = "CART_GET";
const CART_DELETE = "CART_DELETE";

// ACTIONS

// Create card
export const createCart = createAction(
  CART_CREATE,
  async (
    data: ShoppingCart,
    callback?: (cart: ShoppingCartResponse | Boolean) => void
  ) => {
    try {
      let cart: ShoppingCartResponse;

      cart = await api.Cart.create(data);

      if (!checkEmptyObject(cart)) {
        callback && callback(false);
        return null;
      }
      callback && callback(cart);
      return cart;
    } catch (error) {
      callback && callback(false);
      return null;
    }
  }
);


// Get carts
export const getMyCarts = createAction(
  CART_LIST,
  async (
    queryParams: any = {},
    callback?: (cart: ShoppingCartListParsed | Boolean) => void
  ) => {
    const searchParams = {
      ...queryParams,
      sortOption: AdsSortOption.DateDesc,
      itemPerPage: queryParams.itemPerPage || config.maxAdPerPage,
    }

    let carts: ShoppingCartList;

    try {
      carts = await api.Cart.myList(
        searchParams,
      );

      if (!checkEmptyObject(carts)) {
        callback && callback(false);
        return null;
      }

      const data = {
        data: parseShoppingCartData(carts.data),
        count: carts.count,
        page: carts.currentPage,
        nextPage: carts.nextPage,
        previousPage: carts.previousPage,
      }

      callback && callback(data);
      return data;
    } catch (error) {
      callback && callback(false);
      return null;
    }
  }
);

export const deleteCart = createAction(
  CART_DELETE,
  async (
    cartId: string,
    callback?: (cart: ShoppingCartParsed | Boolean) => void
  ) => {
    try {
      await api.Cart.delete(cartId);

      callback && callback(true);
      return true;
    } catch (error) {
      callback && callback(false);
      return false;
    }
  }
);

export const selectCarts = (state: rootReducerInterface) =>
  state.cart.carts;

// INITIAL STATE
const initialState: cartInterface = {
  cart: null,
  carts: null,
};


// REDUCERS
const cartReducers = {
  getCart: (state: cartInterface, { payload }) => ({
    ...state,
    cart: !payload ? {} : { ...payload }
  }),
  getCarts: (state: cartInterface, { payload }) => ({
    ...state,
    carts: !payload ? {} : payload
  }),
  createCart: (state: cartInterface, { payload }) => ({
    ...state,
    cart: !payload ? {} : { ...payload }
  })
};

export default handleActions(
  {
    [CART_CREATE]: cartReducers.createCart,
    [CART_GET]: cartReducers.getCart,
    [CART_LIST]: cartReducers.getCarts,
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/Cart/cart.ducks.ts